<template>
  <section class="c-main-image">
    <div class="c-main-image__parallax-container">
      <div class="c-main-image__title">
        <img :src="logoUrl" alt="" />
      </div>
      <parallax
        :speed-factor="0.3"
        :section-height="20"
        breakpoint="(min-width: 80px)"
      >
        <img :src="imgUrl" alt="" />
      </parallax>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy"

export default {
  name: "MainImageSection",
  components: {
    Parallax
  },
  props: {
    img: {
      type: String
    },
    logo: {
      type: String
    }
  },
  computed: {
    imgUrl() {
      return (
        this.img ||
        "https://s3.amazonaws.com/contest2018/contest_closed/1600-contest_closed_banner.jpg"
      )
    },
    logoUrl() {
      return this.logo || `/img/logo_${this.$i18n.locale}.png`
    }
  }
}
</script>

<style scoped></style>
